(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dtf-help-center"] && !Shopify.designMode) return;
  try {
    
  const initializeDtfHelpCenter = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const search = root.querySelector('[data-dtf-help-search]');
    const clear = root.querySelector('[data-dtf-help-clear]');
    const empty = root.querySelector('[data-dtf-help-empty]');
    const items = Array.from(root.querySelectorAll('[data-dtf-help-item]'));
    const categories = Array.from(root.querySelectorAll('[data-dtf-help-category]'));

    const normalize = (value) => value.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();

    const filterItems = () => {
      const query = normalize(search.value);
      let visibleCount = 0;

      items.forEach((item) => {
        const isVisible = !query || normalize(item.dataset.searchText || '').includes(query);
        item.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      categories.forEach((category) => {
        const categoryVisible = Array.from(category.querySelectorAll('[data-dtf-help-item]')).some((item) => !item.hidden);
        category.hidden = !categoryVisible;
        const key = category.dataset.dtfHelpCategory;
        root.querySelectorAll(`[data-dtf-help-category-link="${key}"], [data-dtf-help-rail-link="${key}"]`).forEach((link) => {
          link.hidden = !categoryVisible;
        });
      });

      empty.hidden = visibleCount !== 0;
      clear.hidden = !search.value;
    };

    const runFilter = () => {
      if (document.startViewTransition) {
        document.startViewTransition(filterItems);
      } else {
        filterItems();
      }
    };

    search.addEventListener('input', runFilter);
    clear.addEventListener('click', () => {
      search.value = '';
      filterItems();
      search.focus();
    });

    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (item.open && history.replaceState) history.replaceState(null, '', `#${item.id}`);
      });
    });

    if (window.location.hash) {
      const target = root.querySelector(window.location.hash);
      if (target && target.matches('[data-dtf-help-item]')) target.open = true;
    }
  };

  document.querySelectorAll('.dtf-help').forEach(initializeDtfHelpCenter);
  document.addEventListener('shopify:section:load', (event) => initializeDtfHelpCenter(event.target.querySelector('.dtf-help')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtf-horizon-menu"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('horizon-header')) {
    class HorizonHeader extends HTMLElement {
      connectedCallback() {
        this.mega = this.querySelector('.hh-mega');
        this.megaItem = this.querySelector('.hh-nav__item--mega');
        this.megaToggle = this.querySelector('.hh-mega-toggle');
        this.drawer = this.querySelector('.hh-drawer');
        this.drawerTrigger = this.querySelector('.hh-mobile-trigger');
        this.drawerClose = this.querySelector('.hh-drawer__close');
        this.closeTimer = null;
        this.bindMegaMenu();
        this.bindDropdowns();
        this.bindDrawer();
        this.boundOutsideClick = this.handleOutsideClick.bind(this);
        document.addEventListener('click', this.boundOutsideClick);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.boundOutsideClick);
      }

      bindMegaMenu() {
        if (!this.mega || !this.megaItem || !this.megaToggle) return;
        const open = () => {
          window.clearTimeout(this.closeTimer);
          this.closeDropdowns();
          this.mega.hidden = false;
          this.megaItem.classList.add('is-open');
          this.megaToggle.setAttribute('aria-expanded', 'true');
        };
        const delayedClose = () => {
          this.closeTimer = window.setTimeout(() => this.closeMega(), 140);
        };
        this.megaItem.addEventListener('mouseenter', open);
        this.megaItem.addEventListener('mouseleave', delayedClose);
        this.mega.addEventListener('mouseenter', open);
        this.mega.addEventListener('mouseleave', delayedClose);
        this.megaToggle.addEventListener('click', (event) => {
          event.stopPropagation();
          if (this.mega.hidden) open(); else this.closeMega();
        });
        this.megaItem.addEventListener('focusin', open);
        this.mega.addEventListener('focusout', (event) => {
          if (!this.mega.contains(event.relatedTarget) && !this.megaItem.contains(event.relatedTarget)) this.closeMega();
        });
      }

      bindDropdowns() {
        this.querySelectorAll('.hh-dropdown-toggle').forEach((toggle) => {
          toggle.addEventListener('click', (event) => {
            event.stopPropagation();
            const item = toggle.closest('.hh-nav__item');
            const willOpen = !item.classList.contains('is-open');
            this.closeMega();
            this.closeDropdowns();
            if (willOpen) {
              item.classList.add('is-open');
              toggle.setAttribute('aria-expanded', 'true');
            }
          });
        });
      }

      bindDrawer() {
        if (!this.drawer || !this.drawerTrigger || !this.drawerClose) return;
        this.drawerTrigger.addEventListener('click', () => {
          this.drawer.showModal();
          this.drawerTrigger.setAttribute('aria-expanded', 'true');
        });
        this.drawerClose.addEventListener('click', () => this.closeDrawer());
        this.drawer.addEventListener('click', (event) => {
          if (event.target === this.drawer) this.closeDrawer();
        });
        this.drawer.addEventListener('close', () => this.drawerTrigger.setAttribute('aria-expanded', 'false'));
      }

      closeDrawer() {
        if (this.drawer.open) this.drawer.close();
      }

      closeMega() {
        if (!this.mega || !this.megaItem || !this.megaToggle) return;
        this.mega.hidden = true;
        this.megaItem.classList.remove('is-open');
        this.megaToggle.setAttribute('aria-expanded', 'false');
      }

      closeDropdowns() {
        this.querySelectorAll('.hh-nav__item.is-open:not(.hh-nav__item--mega)').forEach((item) => {
          item.classList.remove('is-open');
          const toggle = item.querySelector('.hh-dropdown-toggle');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
        });
      }

      handleOutsideClick(event) {
        if (!this.contains(event.target)) {
          this.closeMega();
          this.closeDropdowns();
        }
      }
    }
    customElements.define('horizon-header', HorizonHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
